'use strict';
let $body = $('body');
// method to enable floating label of input field(s)
function initMaterialInputFields() {
    let inputfield = '.material-input .input-text, .material-input .input-textarea';

    // animate label when fields have saved date
    $(window).on('load', function() {
        $(inputfield).length && $(inputfield).each(function(){
            let materialInput = $(this).closest('.material-input');
            if ($(this).val() !== '' && !$(this).hasClass('areacode')) {
                if (!materialInput.find('.icon_checkmark').length) {
                    $(this).hasClass('valid') && $(this).closest('.field-wrapper').addClass('is-valid');
                    $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
                    ($(this).hasClass('phonenumber') && $(this).val().length < 4) && materialInput.find('.icon_checkmark').remove();
                    $(this).hasClass('country') && materialInput.find('.icon_checkmark').remove();
                }
            }
        });
    });

    // animate label on focus-in event
    $body.on('focusin', inputfield, function() {
        let materialInput = $(this).closest('.material-input');
        materialInput.addClass('focus-in');
    });

    $body.on('focus keyup', inputfield, function() {
        let materialInput = $(this).closest('.material-input');
        $(this).closest('.field-wrapper').removeClass('is-valid');
        materialInput.find('.icon_checkmark').remove();
    });

    // reset label on focus-out event
    $body.on('focusout', inputfield, function() {
        let materialInput = $(this).closest('.material-input');
        if($(this).val() === '') {
            materialInput.removeClass('focus-in');
        }

        if ($(this).hasClass('valid')) {
            $(this).closest('.field-wrapper').addClass('is-valid');
            !materialInput.find('.icon_checkmark').length && $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
        }

        ($(this).hasClass('phonenumber') && $(this).val().length < 4) && materialInput.find('.icon_checkmark').remove();
        
        if (
            $(this).hasClass('error') || 
            ($(this).hasClass('address2') && !$(this).val()) || 
            ($(this).hasClass('lastname2') && !$(this).val()) ||
            ($(this).hasClass('birthyear') && !$(this).val())
        ) {
            $(this).closest('.field-wrapper').removeClass('is-valid');
            materialInput.find('.icon_checkmark').remove();
        }
    });

    // reset checkout billing address form
    if($('#same-as-shipping').length) {
        $('#same-as-shipping').on('change', function() {
            $(inputfield).length && $(inputfield).each(function(){
                let materialInput = $(this).closest('.material-input');
                materialInput.removeClass('focus-in');
                if($(this).val() !== '' && !$(this).hasClass('areacode')) {
                    materialInput.addClass('focus-in');
                }
            });
        });
    }   

    if($('.nationalIDNumber .input-text').val() !== '') {
        $('.nationalIDNumber .input-text').closest('.material-input').addClass('focus-in');
    }
}

function setEditMaterialFields(elementClassName) {
    let isRendered = null;
    if(isRendered){
        clearTimeout(isRendered);
    }
    isRendered = setTimeout(function() {
        let $materialFields = $body.find(elementClassName);
        $materialFields.length && $materialFields.each(function(){
            if($(this).val() !== '' && !$(this).hasClass('areacode')) {
                $(this).closest('.material-input').addClass('focus-in');
                if (!$(this).closest('.material-input').find('.icon_checkmark').length) {
                    $(this).hasClass('valid') && $(this).closest('.field-wrapper').addClass('is-valid');
                    $('<i class=\'icon_checkmark\'></i>').insertBefore($(this));
                    ($(this).hasClass('phonenumber') && $(this).val().length < 4) && $(this).closest('.material-input').find('.icon_checkmark').remove();
                    $(this).hasClass('country') && $(this).closest('.material-input').find('.icon_checkmark').remove();
                }
            }
        });
    }, 1000);
}

export default {
    init : function() {
        initMaterialInputFields(); // material input init
    },
    setEditMaterialFields: setEditMaterialFields
}
